import React from 'react';
import { PROJECT_LINKS } from '../projectLinks';

const ExternalLinkNote = () => (
    <span className="sr-only"> (yeni sekmede açılır)</span>
);

const ProjectFooter = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="page-footer">
            <div className="page-shell">
                <div className="footer-grid">
                    <section
                        className="footer-identity"
                        aria-labelledby="footer-project-title"
                    >
                        <p className="footer-kicker">Bağımsız veri projesi</p>
                        <h2 id="footer-project-title">
                            Türkiye Yazılımcı Maaşları
                        </h2>
                        <p>
                            Türkiye’deki yazılım maaşlarını pozisyon, deneyim
                            ve şirket büyüklüğüne göre inceleyen bağımsız veri
                            analizi projesi.
                        </p>
                    </section>

                    <nav
                        className="footer-column"
                        aria-labelledby="footer-links-title"
                    >
                        <h2 id="footer-links-title">Bağlantılar</h2>
                        <ul className="footer-links">
                            <li>
                                <a
                                    href={PROJECT_LINKS.github}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    GitHub
                                    <span aria-hidden="true">↗</span>
                                    <ExternalLinkNote />
                                </a>
                            </li>
                            <li>
                                <a
                                    href={PROJECT_LINKS.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    LinkedIn
                                    <span aria-hidden="true">↗</span>
                                    <ExternalLinkNote />
                                </a>
                            </li>
                            <li>
                                <a href={`mailto:${PROJECT_LINKS.email}`}>
                                    E-posta
                                    <span aria-hidden="true">↗</span>
                                </a>
                            </li>
                        </ul>
                        <p className="footer-contact">
                            Herhangi bir soru, geri bildirim veya düzeltme için{' '}
                            <a href={`mailto:${PROJECT_LINKS.email}`}>
                                {PROJECT_LINKS.email}
                            </a>{' '}
                            adresinden ulaşabilirsiniz.
                        </p>
                    </nav>

                    <section
                        className="footer-column"
                        aria-labelledby="footer-source-title"
                    >
                        <h2 id="footer-source-title">Veri Kaynağı</h2>
                        <a
                            className="footer-source-link"
                            href={PROJECT_LINKS.source}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Önceki Yazılımcı — 2026 Yazılım Sektörü Maaşları
                            <span aria-hidden="true">↗</span>
                            <ExternalLinkNote />
                        </a>
                        <p>
                            Ham anket verileri açık kaynak olarak yayımlanan bu
                            depodan alınmıştır.
                        </p>
                    </section>
                </div>

                <div className="footer-bottom">
                    <p>
                        © {currentYear} Ege Aksoy. Bağımsız veri analizi ve
                        görselleştirme projesi.
                    </p>
                    <a href="#page-title">
                        Yukarı dön <span aria-hidden="true">↑</span>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default ProjectFooter;
